import NBType, { InferType } from '@netbase/nb-type'
import MeasureType from '../enums/MeasureType'

const MetricItemSchema = NBType.object().shape('MetricItemSchema', {
  /* @prop */
  category: NBType.enum(MeasureType),
  /* @prop */
  metricName: NBType.string(),
  /* @prop */
  shown: NBType.boolean(),
  /* @prop */
  selected: NBType.boolean()
  /* END */
})

export default MetricItemSchema
export type MetricItem = InferType<typeof MetricItemSchema>
// RESERVE BELOW
